import { WalletIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Wallet = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <WalletIcon color={fill} {...rest} size={Sizes[size]} />;
};

Wallet.displayName = 'Wallet';
